module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Regular.6734abd9.ttf";